import { DateTime } from "luxon";

import { QueryDateRange } from "@/hooks/query/useQueryDateRange.ts";
import { Periodicities, Periodicity } from "@/uiKit/molecules/period-picker/PeriodSelector.tsx";
import { DateUtils } from "@/utils/dateUtils.ts";

export const customPeriodicity = (duration: number) => ({
  durationInDays: duration,
  label: "periodicity.customize",
  index: 5,
});

export const periodicity7Days = {
  durationInDays: 7,
  label: "periodicity.oneWeek",
  index: 0,
};

export const periodicity14Days = {
  durationInDays: 14,
  label: "periodicity.twoWeeks",
  index: 1,
};

export const periodicity30Days = {
  durationInDays: 30,
  label: "periodicity.oneMonth",
  index: 2,
};

export const periodicity90Days = {
  durationInDays: 90,
  label: "periodicity.threeMonths",
  index: 3,
};

export const periodicity180Days = {
  durationInDays: 180,
  label: "periodicity.sixMonths",
  index: 4,
};

export const periodicities: Periodicities = [
  periodicity7Days,
  periodicity14Days,
  periodicity30Days,
  periodicity90Days,
  periodicity180Days,
];

export const getCurrentPeriodicity = (from: DateTime, to: DateTime): Periodicity => {
  const diff = DateUtils.compareDates(to, from) + 1;
  return periodicities.find(e => e.durationInDays == diff) ?? customPeriodicity(diff);
};

export const getDateRangeAndPeriodicity = (dateRange?: QueryDateRange) => {
  if (!dateRange) {
    return {
      from: DateTime.now().minus({ days: periodicities[1].durationInDays }),
      to: DateTime.now().minus({ days: 1 }),
      periodicity: periodicities[1],
    };
  }

  const from = dateRange.from;
  const to = dateRange.to;

  const periodicity = getCurrentPeriodicity(from, to);

  return { from, to, periodicity };
};
